const DenyRequestButton = ({ onClicked }) => {
  return (
    <div
      onClick={onClicked}
      className="cursor-pointer w-[180px] h-[32px] bg-white rounded-[8px] border-solid border-[1px] border-[#FCA5A5] shadow-[0_1px_2px_0_rgba(16,24,40,0.05)] hover:bg-[#FEF2F2] flex items-center justify-center font-OpenSansSemiBold text-[14px] leading-[20px] tracking-[0.14px] text-[#DC2626]"
    >
      DENY REQUEST
    </div>
  );
};

export default DenyRequestButton;
